import Vue from 'vue'
import Router from 'vue-router'
import HomeLayout from '../components/HomeLayout.vue'
import Home from '../components/Home.vue'
import AboutUs from '../components/AboutUs.vue'
import Fleets from '../components/Fleets.vue'
import Services from '../components/Services.vue'
import ContactUs from '../components/ContactUs.vue'
import Careers from '../components/Careers.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'HomeLayout',
            component: HomeLayout,
            children: [
                {
                    path: '',
                    name: 'Home',
                    component: Home
                },
                {
                    path: '/aboutus',
                    name: 'AboutUs',
                    component: AboutUs
                },
                {
                    path: '/fleets',
                    name: 'Fleets',
                    component: Fleets
                },
                {
                    path: '/services',
                    name: 'Services',
                    component: Services
                },
                {
                    path: '/contactus',
                    name: 'ContactUs',
                    component: ContactUs
                },
                {
                    path: '/careers',
                    name: 'Careers',
                    component: Careers
                }
            ]

        },
        { path: '*', redirect: '/' }
    ]
})